/* istanbul ignore file */
// this file is ignored because react testing library does not provide a way of accessing component instance
// (actually it recommends against it) Until a viable way of testing way is found I'd rather ignore it then write
// incomplete/inaccurate tests.
import * as React from "react";
import { observer } from "mobx-react";
import { Box } from "@draftkings/arena-web";
import { Renderer } from "../Renderer";
const lazyLoadRendererOptions = {
    rootMargin: "0px",
    threshold: 1
};
class LazyLoadComponent extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.loadMoreContent = (isVisible) => {
            if (isVisible) {
                if (this.props.hasMoreContent()) {
                    this.props.loadMoreContent();
                }
            }
        };
        this.state = {
            renderer: new Renderer(Object.assign(Object.assign({}, lazyLoadRendererOptions), { onVisibilityChange: this.loadMoreContent }))
        };
    }
    componentDidMount() {
        this.ref.current && this.state.renderer.registerDom(this.ref.current);
    }
    componentWillUnmount() {
        this.ref.current && this.state.renderer.unRegisterDom(this.ref.current);
    }
    render() {
        return React.createElement(React.Fragment, null,
            this.props.children,
            React.createElement(Box, { ref: this.ref, height: "1px", width: "100%" }));
    }
}
export const LazyLoad = observer(LazyLoadComponent);
//# sourceMappingURL=LazyLoad.js.map